(function () {
  'use strict';

  var STORAGE_KEY = 'mondo:saved';
  var STORAGE_VERSION = 1;

  function readSaved() {
    try {
      var value = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
      if (Array.isArray(value)) return value;
      if (value && value.v === STORAGE_VERSION && Array.isArray(value.items)) return value.items;
    } catch (error) {}
    return [];
  }

  function writeSaved(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ v: STORAGE_VERSION, items: items }));
      return true;
    } catch (error) {
      return false;
    }
  }

  function itemId(item) {
    return String(item && item.id != null ? item.id : item);
  }

  function syncSaveButton(button) {
    var productId = button.getAttribute('data-product-id');
    var saved = readSaved().some(function (item) { return itemId(item) === String(productId); });
    var label = button.querySelector('[data-product-save-label]');
    button.classList.toggle('is-saved', saved);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    if (label) label.textContent = saved
      ? button.getAttribute('data-label-saved') || 'Saved'
      : button.getAttribute('data-label-save') || 'Save';
  }

  function toggleSaved(button) {
    var productId = button.getAttribute('data-product-id');
    var items = readSaved();
    var saved = items.some(function (item) { return itemId(item) === String(productId); });

    if (saved) {
      items = items.filter(function (item) { return itemId(item) !== String(productId); });
    } else {
      items.push({
        id: productId,
        handle: button.getAttribute('data-product-handle') || '',
        savedAt: new Date().toISOString()
      });
    }

    if (writeSaved(items)) syncSaveButton(button);
  }

  function showCopied(button) {
    var label = button.querySelector('[data-product-share-label]');
    var status = button.querySelector('[data-product-share-status]');
    var original = button.getAttribute('data-label-share') || 'Share';
    var copied = button.getAttribute('data-label-copied') || 'Link copied';

    if (label) label.textContent = copied;
    if (status) status.textContent = copied;
    window.setTimeout(function () {
      if (label) label.textContent = original;
      if (status) status.textContent = '';
    }, 1600);
  }

  function fallbackShare(button, url) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () {
        showCopied(button);
      }).catch(function () {
        window.prompt('Copy link', url);
      });
      return;
    }
    window.prompt('Copy link', url);
  }

  function shareProduct(button) {
    var url = button.getAttribute('data-share-url') || window.location.href;
    var title = button.getAttribute('data-share-title') || document.title;

    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
      return;
    }
    fallbackShare(button, url);
  }

  document.querySelectorAll('[data-product-save]').forEach(syncSaveButton);

  document.addEventListener('click', function (event) {
    var saveButton = event.target.closest('[data-product-save]');
    if (saveButton) {
      toggleSaved(saveButton);
      return;
    }

    var shareButton = event.target.closest('[data-product-share]');
    if (shareButton) shareProduct(shareButton);
  });
})();
